export const status = {
    success:"success",
    failed:"failed"
}